import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button/Button';
import { CustomSelect } from '../../../components/Shared/CustomSelect';
import { InputSearch } from '../../../components/InputSearch';
import { useQuery } from '../../../utils/useQuery';
import { useSetFilters } from '../../../hooks/useSetFilters';
import { FormField } from '../../../components/FormField';

export const Filter = ({ restaurants, tags }) => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();
    const query = useQuery();

    const name = query.get('name') || '';
    const restaurantId = parseInt(query.get('restaurant') || '');
    const tagId = query.get('tag') || '';
    const type = query.get('type') || '';
    const status = query.get('status') || '';
    const orderId = query.get('orderId') || '';

    const onSearch = (e) => {
        setFilters({ page: 1, [e.target.name]: e.target.value });
    };

    const onChangeStore = ({ value }) => setFilters({ page: 1, restaurant: value });
    const onChangeStoreType = ({ value }) => setFilters({ page: 1, type: value });
    const onChangeStoreStatusType = ({ value }) => setFilters({ page: 1, status: value });
    const onChangeTag = ({ value }) => setFilters({ page: 1, tag: value });

    // store select options
    const restaurantOptions = [
        { value: '', label: t('All stores') },
        ...restaurants.map((res) => ({
            label: res.name,
            value: res.id,
        })),
    ];
    const defaultRestaurant = restaurantOptions.find((res) => res.value === restaurantId) || null;

    // store type select options delivery, dinein, pickup
    const restaurantTypeOptions = [
        { value: null, label: t('All types') },
        { value: 'dinein', label: t('order_type.dinein') },
        { value: 'delivery', label: t('order_type.delivery') },
        { value: 'pickup', label: t('order_type.pickup') },
    ];

    const defaultRestaurantType = restaurantTypeOptions.find((res) => res.value === type) || null;

    // store status pending, confirmed, ready, completed, canceled, draft
    const restaurantStatusOptions = [
        { value: null, label: t('All statuses') },
        { value: 'pending', label: t('status.pending') },
        { value: 'confirmed', label: t('status.confirmed') },
        { value: 'ready', label: t('status.ready') },
        { value: 'completed', label: t('status.completed') },
        { value: 'canceled', label: t('status.canceled') },
        { value: 'draft', label: t('status.draft') },
    ];

    const defaultRestaurantStatus = restaurantStatusOptions.find((res) => res.value === status) || null;

    // tags options
    const tagsOptions = [
        { value: null, label: t('All tags') },
        ...tags.map((res) => ({
            label: res.name.en,
            value: res.name.en,
        })),
    ];
    const defaultTag = tagsOptions.find((res) => res.value === tagId) || null;

    return (
        <div className="">
            <div className="flex flex-col gap-4">
                <div className="flex justify-between gap-6">
                    <div className="flex gap-3">
                        <FormField>
                            <CustomSelect placeholder={t('All stores')} className="text-left min-w-[125px]" options={restaurantOptions} value={defaultRestaurant} onChange={onChangeStore} />
                        </FormField>
                        <FormField>
                            <CustomSelect placeholder={t('All statuses')} className="text-left min-w-[125px]" options={restaurantStatusOptions} value={defaultRestaurantStatus} onChange={onChangeStoreStatusType} />
                        </FormField>
                        <FormField>
                            <CustomSelect placeholder={t('All types')} className="text-left min-w-[140px]" options={restaurantTypeOptions} value={defaultRestaurantType} onChange={onChangeStoreType} />
                        </FormField>
                        <FormField>
                            <CustomSelect placeholder={t('All tags')} className="text-left min-w-[120px]" options={tagsOptions} value={defaultTag} onChange={onChangeTag} />
                        </FormField>
                    </div>
                    <div>
                        <Button>{t('Export Report')}</Button>
                    </div>
                </div>
                <div className="flex gap-3">
                    <InputSearch defaultValue={name} name="name" onChange={onSearch} className="w-[200px]" placeholder={t('Client name')} />
                    <InputSearch searchIcon={false} defaultValue={orderId} name="orderId" onChange={onSearch} className="w-[140px] pl-2" placeholder={t('Order Id')} />
                </div>
            </div>
        </div>
    );
};
